import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from "@angular/router";
import { AuthService } from "../Services/auth";
import { EncryptionService } from "../Services/encryption";

@Injectable({ providedIn: "root" })
export class RedirectIfLoggedInGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private encryptionService: EncryptionService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree {
    try {
      const dmttLogout = route.queryParamMap.get("dmtt_logout") === "1";
      const blLogout = route.queryParamMap.get("bl_logout") === "1";
      if (dmttLogout || blLogout) {
        return true;
      }

      if (
        this.authService &&
        this.authService.isLoggedIn &&
        this.authService.isLoggedIn()
      ) {
        // If logged in, redirect to dashboard
        // let binExist = this.encryptionService.decrypt(
        //   localStorage.getItem("bin")?.toString() || "",
        // );

        // if (binExist !== "") {
        //   this.authService.checkSessionValidity(binExist).subscribe({
        //     next: (resp: any) => {
        //       console.log(resp);
        //       try {
        //         const sessionData = resp?.response || {};
        //         if (sessionData.is_session_active === "N") {
        //           this.authService.signOut();
        //           return this.router.createUrlTree(["/"]);
        //         } else {
        //           return this.router.createUrlTree(["/dashboard"]);
        //         }
        //       } catch (err) {
        //         console.log(err);
        //         this.authService.signOut();
        //         return this.router.createUrlTree(["/"]);
        //       }
        //     },
        //   });
        // } else {
        //   console.log(this.router.url);
        //   this.authService.signOut();
        //   const isDmttLoggedOut =
        //     document.cookie
        //       .split("; ")
        //       .find((row) => row.startsWith("dmtt_logout="))
        //       ?.substring("dmtt_logout=".length) ?? null;
        //   if (isDmttLoggedOut === "yes") {
        //     this.router.createUrlTree(["/signup/dmtt"]);
        //   } else {
        //     return false;
        //   }
        // }

        return this.router.createUrlTree(["/dashboard"]);
      }
    } catch (e) {
      console.warn("RedirectIfLoggedInGuard check failed", e);
    }
    return true;
  }
}
